import type { UserRedirectedNextStep } from '@/types';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNavigationStore = defineStore('navigation', () => {
  const redirectingToExternal = ref(false);
  const userRedirectedNextStep = ref<UserRedirectedNextStep | null>(null);

  function setUserRedirectedNextStep(data: UserRedirectedNextStep | null) {
    userRedirectedNextStep.value = data;
  }

  return {
    redirectingToExternal,
    userRedirectedNextStep,
    setUserRedirectedNextStep,
  };
});
